const loadSurfaces = async (component) => {
  component.surfaces = await component.fetchSurfaces()
}

export default loadSurfaces
